// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"355":"fa09d828","453":"f9bd6525"}[chunkId] + ".chunk.js");